<template>
    <div>
        当月数据
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>